module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/333.154549a9.png";